var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import forwardRef from "../../private/forwardRef";
import { replaceToken } from "../../private/helpers";
var InlineContainer = styled.div.withConfig({
  displayName: "Inline__InlineContainer",
  componentId: "sc-lf7x8d-0"
})(["display:flex;flex-direction:row;justify-content:", ";align-items:", ";padding:", ";& > *{flex-grow:", ";}& > *:not(:last-child){margin-right:", ";}"], function (props) {
  return props.justifyContent;
}, function (props) {
  return props.alignItems;
}, function (_ref) {
  var theme = _ref.theme,
    inset = _ref.inset;
  return replaceToken(theme.spacing, inset);
}, function (_ref2) {
  var grow = _ref2.grow;
  return grow ? 1 : 0;
}, function (_ref3) {
  var theme = _ref3.theme,
    gap = _ref3.gap;
  return replaceToken(theme.spacing, gap);
});

/**
 * This lays child components horizontally.
 *
 * @see [Inline documentation](https://construct-kit.reainternal.net/web/inline#examples)
 */
var Inline = forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
    props = _objectWithoutPropertiesLoose(_ref4, _excluded);
  return /*#__PURE__*/React.createElement(InlineContainer, _extends({
    ref: ref
  }, props), children);
});
Inline.displayName = "Inline";
Inline.propTypes = {
  /** Sets the padding of the container. Accepts named spacing units. */
  inset: PropTypes.string,
  /** Defines how content items are laid along the horizontal axis. Accepts standard [flexbox `justify-content`](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content) property values. */
  justifyContent: PropTypes.string,
  /** Defines how content items are laid along the vertical axis. Accepts standard [flexbox `align-items`](https://developer.mozilla.org/en-US/docs/Web/CSS/align-items) property values. */
  alignItems: PropTypes.string,
  /** Sets the margin between child components within the container. Accepts
   * named spacing units. */
  gap: PropTypes.string,
  /** Allows elements to fill the remaining space in the container */
  grow: PropTypes.bool
};
Inline.defaultProps = {
  inset: "0",
  gap: "1.5rem",
  justifyContent: "flex-start",
  alignItems: "center",
  grow: true
};
export default Inline;